export default {
  dynamicFormList: []
}
